import React from "react";
import lazyLoad from "common/utils/lazyLoad";
import { Flex, Card, LoadingIndicator } from "@jsq/ds/core";
import styles from "./styles.scss";

export const SubscriptionProgressTrackerLoaderFallback = () => (
  <Card className={styles.SubscriptionProgressTracker__Card}>
    <Flex justifyContent="center" alignItems="center">
      <LoadingIndicator variant="primary" />
    </Flex>
  </Card>
);

export default lazyLoad(
  () => import(/* webpackChunkName: "SubscriptionProgressTrackerPillar" */ "."),
  <SubscriptionProgressTrackerLoaderFallback />,
);
